export default __webpack_public_path__ + "static/media/Delete.95350e61.svg";